// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FZf","hidden":"FZb-","bottomIntend":"FZzr","closeBtnWrap":"FZzt","closeBtn":"FZcx"};